import { Routes } from '@angular/router';
import { AuthGuard } from '../../../core/guards/auth.guard';

export const publishContentRoutes: Routes = [
  {
    path: 'product-texture',
    loadComponent: () => import('./publish-product-texture/publish-product-texture.component').then(m => m.PublishProductTextureComponent),
    children: [
      { path: '', redirectTo: 'product', pathMatch: 'full' },

      {
        path: 'product',
        canDeactivate: [AuthGuard],
        loadComponent: () => import('./publish-product-texture/publish-product/publish-product.component').then(c => c.PublishProductComponent)
      },

      {
        path: 'texture',
        canDeactivate: [AuthGuard],
        loadComponent: () => import('./publish-product-texture/publish-texture/publish-texture.component').then(c => c.PublishTextureComponent)
      }
    ]
  },

  {
    path: 'news', canDeactivate: [AuthGuard], loadComponent: () => import('./publish-news/publish-news.component').then(c => c.PublishNewsComponent)
  },

  {
    path: 'video', canDeactivate: [AuthGuard], loadComponent: () => import('./publish-video/publish-video.component').then(c => c.PublishVideoComponent)
  },

  {
    path: 'catalogue', canDeactivate: [AuthGuard], loadComponent: () => import('./publish-catalogue/publish-catalogue.component').then(c => c.PublishCatalogueComponent)
  },

  { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
];
